import React from 'react';
import { ErrorState } from '../../../CommonComponents/OPL/AsyncStates/ErrorState/ErrorState';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { useAllocationTab } from '../../hooks/useAllocationTab';
import { AssetAllocationChartLoading } from './AssetAllocationChart.loading';
import { AssetAllocationChartContent } from './components/AssetAllocationChartContent/AssetAllocationChartContent';

interface Props {
  tab: 'left' | 'right';
}

export const AssetAllocationChart = ({ tab }: Props) => {
  const { isFetching, isError, refetch, data } = useAllocationTab({ tab });

  if (isFetching) {
    return <AssetAllocationChartLoading />;
  }

  if (isError) {
    return (
      <Box display="flex" flex="1" alignItems="center" justifyContent="center">
        <ErrorState onAction={refetch} />
      </Box>
    );
  }

  if (!data) {
    return null;
  }

  const { name, chartData } = data;

  return <AssetAllocationChartContent name={name} chartData={chartData} />;
};
